import { KeyFilterPattern } from 'primeng/keyfilter';
import {
  EoFormControlConfig,
  IEoFormControlConfig,
} from '../eo-form/eo-form.config';

export interface IEoRichtextConfig extends IEoFormControlConfig {
  type?: 'richtext';
  autoResize?: boolean;
  rows?: number;
  cols?: number;
  maxlength?: number;
  minlength?: number;
  placeholder?: string;
  readonly?: boolean;
  disabled?: boolean;
  resizable?: boolean;
  showClear?: boolean;
  inputStyleClass?: string;
  pKeyFilter?: RegExp | KeyFilterPattern | null;
}

export class EoRichtextConfig extends EoFormControlConfig implements IEoRichtextConfig {
  override type?: 'richtext';
  autoResize?: boolean;
  rows?: number;
  cols?: number;
  maxlength?: number;
  minlength?: number;
  placeholder?: string;
  readonly?: boolean;
  disabled?: boolean;
  resizable?: boolean;
  showClear?: boolean;
  inputStyleClass?: string;
  pKeyFilter?: RegExp | KeyFilterPattern | null;

  constructor();
  constructor(obj: IEoRichtextConfig);
  constructor(obj?: IEoRichtextConfig) {
    super(obj as IEoFormControlConfig);
    this.type = 'richtext';
    this.autoResize = obj?.autoResize ?? false;
    this.rows = obj?.rows ?? 2;
    this.cols = obj?.cols ?? 20;
    this.maxlength = obj?.maxlength;
    this.minlength = obj?.minlength;
    this.placeholder = obj?.placeholder;
    this.readonly = obj?.readonly ?? false;
    this.disabled = obj?.disabled ?? false;
    this.resizable = obj?.resizable ?? true;
    this.showClear = obj?.showClear ?? false;
    this.inputStyleClass = obj?.inputStyleClass;
    this.pKeyFilter = obj?.pKeyFilter;
  }
}